import { addDoc, collection, getDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { CreateLanguageAssistant, LanguageAssistant } from "../type";

export const createLanguageAssistant = async (
  languageAssistant: CreateLanguageAssistant,
): Promise<LanguageAssistant | null> => {
  const collectionRef = collection(db, "languagesAssistants");

  const docRef = await addDoc(collectionRef, languageAssistant);

  const snapshot = await getDoc(docRef);

  if (!snapshot.exists()) return null;

  return { id: docRef.id, ...snapshot.data() } as LanguageAssistant;
};
